// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminFedex = (client) => ({
    /**
     * `POST /admin/fedex`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-fedex-v2/src/api/admin/fedex/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/fedex", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/fedex`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-fedex-v2/src/api/admin/fedex/route.ts
     */
    list: (query, headers) => client.fetch("/admin/fedex", { method: "GET", query, headers }),
});
//# sourceMappingURL=fedex.js.map